import { useEffect, useState, type MouseEvent } from "react";
import { scrollToSection } from "@/pages/home/utils/scrollTo";

const navItems = [
  { id: "addresses", label: "最新地址" },
  { id: "steps", label: "访问步骤" },
  { id: "guide", label: "防走失指南" },
  { id: "troubleshoot", label: "打不开排查" },
  { id: "devices", label: "多设备" },
  { id: "safety", label: "安全提示" },
  { id: "faq", label: "常见问题" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    setMenuOpen(false);
    scrollToSection(id);
  };

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
            setMenuOpen(false);
          }}
          className="flex items-center gap-3 cursor-pointer shrink-0"
        >
          <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
            91
          </span>
          <span className="flex flex-col leading-tight">
            <span className={`font-heading font-bold text-lg ${solid ? "text-foreground-950" : "text-background-50"}`}>
              91免费
            </span>
            <span className={`text-xs ${solid ? "text-foreground-600" : "text-background-50/80"}`}>
              地址发布 · 防走失导航
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => handleNav(e, item.id)}
              className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                solid
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#addresses"
            onClick={(e) => handleNav(e, "addresses")}
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-link-m text-base" />
            查看最新地址
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 rounded-md flex items-center justify-center cursor-pointer ${
              solid ? "text-foreground-900 bg-background-100" : "text-background-50 bg-background-50/15"
            }`}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => handleNav(e, item.id)}
                className="px-3 py-2 rounded-md text-sm text-foreground-800 bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}